import React from "react";
import { FaAward, FaUsers } from "react-icons/fa"; // React icons for Award & Team
import "../Aboutus/Award.css";

const Award = () => {
  return (
    <div className="full-design-container-aba">
      {/* Left Image Section */}
      <div className="image-section-aba">
        <img
          src="/award.webp"
          alt="Orthopedic Packaging"
          className="gardening-image-aba"
        />
      </div>

      {/* Content Section */}
      <div className="content-section-aba">
        <h1 className="experience-years-aba">
          10 <span className="subtext-aba">Years of Experience</span>
        </h1>
        <h2 className="main-title-aba">Precision in Every Package</h2>
        <p className="description-a-aba">
          For over a decade, we’ve specialized in orthopedic instrument
          packaging that ensures safety, hygiene, and compliance—tailored to
          meet the highest medical standards.
        </p>

        {/* Features Section */}
        <div className="features-aba">
          <div className="feature-item-aba">
            <FaAward className="feature-icon-aba" />
            <h3 className="feature-title-aba">Award-Winning Quality</h3>
            <p className="feature-description-aba">
              Honored for innovation and reliability in sterile and secure
              packaging for orthopedic tools worldwide.
            </p>
          </div>
          <div className="feature-item-aba">
            <FaUsers className="feature-icon-aba" />
            <h3 className="feature-title-aba">Expert Packaging Team</h3>
            <p className="feature-description-aba">
              Our trained specialists ensure each package meets stringent
              medical requirements with precision and care.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Award;
